import { useEffect } from "react";
import { applySeo, type SeoOptions } from "@/lib/seo";

/**
 * Apply per-route SEO tags. Pass a stable opts object or memoize values.
 * Defaults to robots="index,follow". For private pages pass robots="noindex,follow".
 */
export function useSeo(opts: SeoOptions | null | undefined) {
  useEffect(() => {
    if (!opts) return;
    applySeo(opts);
    // We intentionally serialize for cheap deep-equality on dynamic data.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(opts)]);
}
